import React, { useState } from "react";
import SummaryApi from "../../common";

const CreateNotifications = () => {
  const [notificationData, setNotificationData] = useState({
    title: "",
    message: "",
    recipient: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNotificationData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const createNotification = async () => {
    try {
      const response = await fetch(SummaryApi.createNotification.url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(notificationData),
      });

      if (!response.ok) {
        throw new Error("Failed to create notification");
      }

      const result = await response.json();
      console.log("Notification created:", result);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div>
      <h2>Create Notification</h2>
      <div>
        <label htmlFor="title">Title:</label>
        <input
          type="text"
          id="title"
          name="title"
          value={notificationData.title}
          onChange={handleInputChange}
        />
      </div>
      <div>
        <label htmlFor="message">Message:</label>
        <textarea
          id="message"
          name="message"
          value={notificationData.message}
          onChange={handleInputChange}
        />
      </div>
      <div>
        <label htmlFor="recipient">Recipient:</label>
        <input
          type="text"
          id="recipient"
          name="recipient"
          value={notificationData.recipient}
          onChange={handleInputChange}
        />
      </div>
      <button onClick={createNotification}>Create Notification</button>
    </div>
  );
};

export default CreateNotifications;












